import useCurrentCountry from './useCurrentCountry';
import { useDataSourceVersion } from './useDataSourceVersion';

function useInstagramWeeks() {
    const country = useCurrentCountry();
    const { instagramVersion: query } = useDataSourceVersion();
    const { week, year } = query.data?.countries?.[country?.text_id] || {};
    return { week, year, query };
}

export default useInstagramWeeks;
